import { useCallback } from "react";
import { useLockedPositionAPY } from "@/hooks";

interface UseAnnualProjectedEarningsResult {
    apy: string;
    isAPYLoading: boolean;
    calculateProjectedEarnings: (amount: string) => string;
}

export function useAnnualProjectedEarnings(duration: number, amount: number): UseAnnualProjectedEarningsResult {
    const { apy, isAPYLoading } = useLockedPositionAPY(duration, amount);

    const calculateProjectedEarnings = useCallback(
        (amount: string) => {
            // Calculate earnings for the specified duration in weeks
            const annualEarnings = Number(amount) * (Number(apy) / 100);

            return annualEarnings.toFixed(2);
        },
        [apy, duration],
    );

    return {
        apy,
        isAPYLoading,
        calculateProjectedEarnings,
    };
}
